import React, { CSSProperties } from 'react'
import InventoryItemSelector from './InventoryItemSelector'
import { ASSET_DISABLED_MESSAGE } from '@/config/inventory'
import { FrozenAssetIndicator } from './FrozenAssetIndicator'

type Props = {
  isSmallLayout: boolean
  disabledReason: string
  style?: CSSProperties
  isHovered: boolean
  disabled: boolean
  selected: boolean
  selectable: boolean
  onChange: () => void
}

export default function AssetStatusCircle({
  isSmallLayout,
  selectable,
  disabledReason,
  disabled,
  style,
  isHovered,
  selected,
  onChange
}: Props) {
  const inventoryItemSelectorStyles: CSSProperties = {
    width: `${isSmallLayout ? 'max(24px, 3.5em)' : 'max(24px, 4em)'}`,
    height: `${isSmallLayout ? 'max(24px, 3.5em)' : 'max(24px, 4em)'}`
  }

  const className = 'absolute z-[3]'
  const styles = { ...style, ...inventoryItemSelectorStyles }

  if (disabledReason) {
    return (
      <FrozenAssetIndicator
        className={className}
        message={ASSET_DISABLED_MESSAGE[disabledReason]}
        style={styles}
      />
    )
  }

  if (!selectable) return null

  return (
    <InventoryItemSelector
      className={className}
      style={styles}
      selected={selected}
      disabled={disabled}
      isSmallLayout={isSmallLayout}
      isHovered={isHovered}
      onChange={onChange}
    />
  )
}
